import { useThemeStore } from '@/stores/theme'

export function useTheme() {
  return useThemeStore()
}
